import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface GameCodeState {
  url?: string
  gameCode: string
}

const initialState: GameCodeState = {
  url: '',
  gameCode: '',
}

export const gameCodeSlice = createSlice({
  name: 'gameCode',
  initialState,
  reducers: {
    setGameCode: (state, action: PayloadAction<GameCodeState>) => {
      state.url = action.payload?.url ?? state.url
      state.gameCode = action.payload.gameCode
    },
    clearGameCode: (state) => {
      state.gameCode = ''
      state.url = ''
    },
  },
})

export const { setGameCode, clearGameCode } = gameCodeSlice.actions

export default gameCodeSlice.reducer
